import '@/styles/index.css'
import { loadDictionary } from '@/i18n'
import { isLocale } from '@/i18n/locales'

// The page arrives fully rendered, so React is fetched and started only after the browser has
// painted it; nothing here competes with the fonts and the hero photo. The timeout covers
// background tabs, where nothing is painted until the tab is opened.
const FALLBACK_DELAY_MS = 2000

let started = false

const start = (): void => {
  if (started) return
  started = true

  // Fetch the language chunk alongside the app code instead of after it.
  const locale = document.getElementById('root')?.dataset.routeLocale
  if (locale !== undefined && isLocale(locale)) void loadDictionary(locale)

  void import('@/hydrate')
}

if (
  typeof PerformanceObserver !== 'undefined' &&
  PerformanceObserver.supportedEntryTypes.includes('paint')
) {
  const observer = new PerformanceObserver(() => {
    observer.disconnect()
    start()
  })
  observer.observe({ type: 'paint', buffered: true })
} else {
  requestAnimationFrame(() => {
    requestAnimationFrame(start)
  })
}

setTimeout(start, FALLBACK_DELAY_MS)
